const initialState = 1;

const emailAddressesPaginationReducer = (state = initialState, action) => {
      switch (action.type) {
            case 'SET_SELECTED_EMAIL_ADDRESSES_PAGE':
                  return action.pageNumber;
            case 'LOGOUT_USER':
                  return 1;
            default:
                  break;
      }
      return state;
};
export default emailAddressesPaginationReducer;